// extracted by mini-css-extract-plugin
export default {"loadingContainer":"styles_loadingContainer__r-ILF","loading":"styles_loading__I4NTM","spin":"styles_spin__IzYtC"};